import { useAuth } from '@data-delivery/okta-auth-react';
import { useLogoutMutation } from '@data-delivery/permission-ui-data-access-state';
import { useCallback } from 'react';

export function useLogout() {
  const auth = useAuth();
  const logoutMutation = useLogoutMutation();

  const logout = useCallback(async () => {
    await auth.logout(async () => {
      await logoutMutation.mutateAsync();
    });
  }, [auth, logoutMutation]);

  return {
    logout,
    isLoggingOut: logoutMutation.isPending,
  };
}
